var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{style:({height: _vm.height > 0 ? _vm.height+'px' : 'auto'}),attrs:{"visible":_vm.show,"append-to-body":"","custom-class":"gcmcn-modal","close-on-click-modal":_vm.closeOnClickModal,"show-close":false},on:{"update:visible":function($event){_vm.show=$event},"close":_vm.handleClose}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f9a3d35","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/gcmcn-modal-theme.vue
// module id = 3f0n
// module chunks = 0